import { createRoot, type Root } from "react-dom/client";
import RedPastoralYouth from "../pages/RedPastoralYouth/RedPastoralYouth";
import "../index.css";
import "../pages/RedPastoralYouth/RedPastoralYouth.custom.css";

let root: Root | null = null;

function mount(element: HTMLElement) {
  if (root) return;

  root = createRoot(element);
  root.render(<RedPastoralYouth />);
}

function unmount() {
  root?.unmount();
  root = null;
}

window.ACADRedPastoralYouth = { mount, unmount };

function boot() {
  const element = document.getElementById("red-pastoral-youth-root");
  if (element) mount(element);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
